import { catchError, map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CountryPhoneDto } from './types/CountryPhoneDto';
import { Observable, of } from 'rxjs';
import { CountryDto } from './types/CountryDto';
import { StateDto } from './types/StateDto';
import { CityDto } from './types/CityDto';
import { PhoneDto } from './types/PhoneDto';
import { ProfileService } from './profile.service';

@Injectable()
export class LocationService {
  usPhone = '1-877-500-4645';

  constructor(private http: HttpClient, private profileService: ProfileService) {}

  getCountries(): Observable<CountryDto[]> {
    return this.http.get<CountryDto[]>('/location-service/countries');
  }

  getStates(countryId: number): Observable<StateDto[]> {
    return this.http.get<StateDto[]>(`/location-service/countries/${countryId}/states`);
  }

  getCities(stateId: number): Observable<CityDto[]> {
    return this.http.get<CityDto[]>(`/location-service/states/${stateId}`);
  }

  getPhoneInfo(phoneId: number): Observable<PhoneDto> {
    return this.http.get<PhoneDto>(`/location-service/phones/${phoneId}`);
  }

  getPhoneWithCountryCode(countryCode: string) {
    return this.http.get('/location-service/countries/' + countryCode).pipe(
      map((res: CountryPhoneDto) => {
        return res;
      })
    );
  }

  getContactPhone() {
    return this.profileService.getContactData().pipe(
      switchMap(({ address: { countryId } }) => {
        if (countryId && countryId !== 1) {
          return this.http.get<CountryDto>(`/location-service/countries/${countryId}`).pipe(
            map((model) => this.lookupCountryNumber(model)),
            catchError(() => of(this.usPhone))
          );
        }
        return this.usPhone;
      })
    );
  }

  getCity(cityId: number) {
     return this.http.get(`https://oe-location-service-ext.openenglish.com/cities/${cityId}`);
  }

  lookupCountryNumber(model: CountryDto) {
    if (model === undefined) {
      return this.usPhone;
    }

    let oeFromModel = model.phone.oeServicePhone;

    if (oeFromModel && oeFromModel.trim().length > 0) {
      return oeFromModel;
    }

    return this.usPhone;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/location.service.ts